

export enum StorageTypeEnum {
    LOCAL = "Local Storage",
    STORAGE = "Files Storage",
    TEMPLATES = "Forms"
}
export interface AbstractPickedFile {
    storageType: StorageTypeEnum;
    isFolder: boolean;
}


export interface LocalPickedFile extends AbstractPickedFile {
    file: File;
}
export interface CloudPickedFile extends AbstractPickedFile {
    storageName: string;
    storageId: number;
    path: string;
}
export interface TemplatePickedFile extends AbstractPickedFile{
    id?: number;    // id is optional, because folders don't have IDs
    path: string;
}